import React, { useState, useEffect } from "react";
import Header from "../Header/Header.js";
import Sidebar from "../Sidebar/Sidebar.js";
import Footer from "../Footer/Footer.js";
import "../../assets/css/Welcome/Welcome.css";
import { Outlet } from "react-router-dom";

function Welcome() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="dashboard">
      <Header
        showProfile={true}
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
      />

      <div className="dashboard-body">
        <Sidebar
          isOpen={isSidebarOpen}
          isMobile={isMobile}
          closeSidebar={() => setIsSidebarOpen(false)}
        />

        <main className="main-content">
          <Outlet />
        </main>
      </div>

      {isSidebarOpen && (
        <div
          className="sidebar-overlay"
          data-testid="sidebar-overlay"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <Footer />
    </div>
  );
}

export default Welcome;